import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text, List, ListItem } from 'components/chroma';

import { VehicleModification } from 'scenes/motor/types';

const HelpTextModal: FunctionComponent<{
  isOpen: boolean;
  vehicleModifications: VehicleModification[];
  onClose: () => void;
}> = ({ isOpen, vehicleModifications, onClose }) => (
  <Modal header="What does this mean?" isOpen={isOpen} onClose={onClose}>
    <Text>
      We consider the following items to be non-standard accessories and
      modifications:
    </Text>
    <List bullet>
      {vehicleModifications.map((modification) => (
        <ListItem key={modification.name}>
          <Text>{modification.description}</Text>
        </ListItem>
      ))}
    </List>
  </Modal>
);

export default HelpTextModal;
